<template>
	<AppDialog :closeRight="'-10'" :closeTop="'-30'" dialogName="WorkspaceChangedDialog" width="500">
		<Col class="dialog-content rounded flex-centerize">
			<h2 class="reg bold mb-6">Your active workspace is now</h2>
			<AppWorkspaceAvatar :account="account" class="mb-7" />
			<Row class="width-100 note mb-9">
				<h3 class="reg">NOTE: Only features from the active workspace are available in your apps</h3>
			</Row>
			<AnemicButton @click="close" class="pa-0 close-button" tile>Got it</AnemicButton>
		</Col>
	</AppDialog>
</template>
<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AppWorkspaceAvatar from '@/components/WorkspaceSelectionMenu/AppWorkspaceAvatar.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
export default {
	name: 'WorkspaceChangedDialog',
	components: { AppDialog, AppWorkspaceAvatar },
	props: { account: { type: Object }, dialogPromiseHandlers: { type: Object } },
	methods: {
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
	},
};
</script>

<style scoped lang="scss">
.dialog-content {
	width: 500px;
	overflow: hidden;
	padding: 40px 70px;
	background: var(--white);
}

.rounded {
	border-radius: 10px;
}
.note {
	text-align: center;
	padding: 14px 42px;
	border-radius: 5px;
	background: #fafbfd;
	border: 1px solid #e2e7f0;
}
.avatar {
	font-size: 12px;
	min-width: 25px;
	min-height: 25px;
	font-weight: 500;
	border-radius: 50%;
	color: var(--white);
}
.close-button {
	width: 122px !important;
	height: 40px !important;
	font-size: 14px !important;
	border-radius: 8px !important;
	letter-spacing: 0px !important;
	color: var(--white) !important;
	font-weight: normal !important;
	text-transform: none !important;
	background: #5858ec !important;
}
</style>
